import React, { useEffect, useState, useContext } from "react";
import { Td, Tr } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import styled from "styled-components/macro";
import FormCrudCRUDContext from "context/FormCrudContex";
import { IconGeneric, IconMenuRUD } from "styled/Icons.styled";
import { MdDelete, MdContentCopy, MdCancel } from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";

const IconAction = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 4px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

const TbodyItems = ({ data, iope }) => {
  const location = useLocation();
  const { FormEntryNumber = "", FormExitNumber = "" } = queryString.parse(
    location.search
  );
  const [erroresLocal, setErroresLocal] = useState([]);
  const {
    setDataToDelete,
    setDataToEditItems,
    setDataToCopyItems,
    onOpenDelete,
    show,
    setShow,
  } = useContext(FormCrudCRUDContext);

  useEffect(() => {
    const updateErroresLocal = () => {
      if (FormEntryNumber || FormExitNumber) {
        const obtenerErrorItem = JSON.parse(
          sessionStorage.getItem(`erroItem-${FormEntryNumber || FormExitNumber}`) ||
            "[]"
        );
        if (obtenerErrorItem) {
          setErroresLocal(obtenerErrorItem);
        }
      }
    };

    updateErroresLocal();
    window.addEventListener("erroItemUpdated", updateErroresLocal);
    return () => {
      window.removeEventListener("erroItemUpdated", updateErroresLocal);
    };
  }, [FormEntryNumber, FormExitNumber]);

  const handleEdit = () => {
    setShow(false);
    setDataToCopyItems(null);
    setDataToEditItems(data);
    setShow(true);
  };

  const handleDelete = () => {
    setDataToDelete(data);
    onOpenDelete();
  };

  const handleCopy = () => {
    setShow(false);
    setDataToEditItems(null);
    setDataToCopyItems(data);
    setShow(true);
  };

  return (
    <Tr
      className={
        erroresLocal && erroresLocal?.includes(data.id) && "BorderError"
      }
    >
      <Td className="text-center">{data?.item}</Td>
      <Td className="text-center">
        {data?.code_subheading ? data?.code_subheading : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.code_product ? data?.code_product : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.description_product ? data?.description_product : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.code_businessUnit ? data?.code_businessUnit : "N/A"}
      </Td>
      <Td className="text-center">{data?.quantity ? data?.quantity : "N/A"}</Td>
      <Td className="text-center">
        {data?.product_quantity ? data?.product_quantity : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.cif_us_value ? data?.cif_us_value : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.us_fob_value ? data?.us_fob_value : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.net_weight ? data?.net_weight : "N/A"}
      </Td>
      <Td className="text-center">
        {data?.gross_weight ? data?.gross_weight : "N/A"}
      </Td>
      <Td isNumeric className="text-center">
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <IconAction onClick={handleEdit} title="Editar">
            <IconMenuRUD as={RiEdit2Fill} />
          </IconAction>
          <IconAction onClick={handleCopy} title="Copiar">
            <IconMenuRUD as={MdContentCopy} />
          </IconAction>
          <IconAction onClick={handleDelete} title="Eliminar">
            <IconMenuRUD as={MdDelete} />
          </IconAction>
        </div>
      </Td>
    </Tr>
  );
};

export default TbodyItems;
